@switch (containerState) {
  @case (ContainerState.contentPlaceholder) {
    <ng-content select="[tiimeContainerContentPlaceholder]"></ng-content>
  }
  @case (ContainerState.onboard) {
    <ng-content select="[tiimeContainerOnboard]"></ng-content>
  }
  @case (ContainerState.noResult) {
    <ng-content select="[tiimeContainerNoResult]"></ng-content>
  }
  @default {
    <ng-content select="[tiimeContainerContent]"></ng-content>
  }
}
